import {createSettingsParams, SettingsParamType} from '@wix/tpa-settings';

export type ISettingsParams = {
  THANK_YOU_PAGE_TITLE: SettingsParamType.String;
  THANK_YOU_PAGE_TITLE_HTML_TAG: SettingsParamType.String;
  THANK_YOU_PAGE_SUBTITLE: SettingsParamType.String;
  THANK_YOU_PAGE_SUBSCRIPTION_TITLE: SettingsParamType.String;
  THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE: SettingsParamType.String;
  THANK_YOU_PAGE_ORDER_NUMBER_LABEL: SettingsParamType.String;
  THANK_YOU_PAGE_TOTAL_COST_LABEL: SettingsParamType.String;
  THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL: SettingsParamType.String;
  THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION: SettingsParamType.String;
  THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT: SettingsParamType.Object;
  THANK_YOU_PAGE_BILLING_ADDRESS_LABEL: SettingsParamType.String;
  THANK_YOU_PAGE_PAYMENT_METHOD_LABEL: SettingsParamType.String;
};

export default createSettingsParams<ISettingsParams>({
  THANK_YOU_PAGE_TITLE: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_TITLE_HTML_TAG: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_SUBTITLE: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_SUBSCRIPTION_TITLE: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_SUBSCRIPTION_SUBTITLE: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_ORDER_NUMBER_LABEL: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_TOTAL_COST_LABEL: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_SHIPPING_ADDRESS_LABEL: {
    type: SettingsParamType.String,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_CONTINUE_BROWSING_LINK_CAPTION: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.continueBrowsing.footerLink'),
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_CONTINUE_SHOPPING_LINK_OBJECT: {
    type: SettingsParamType.Object,
    // @ts-expect-error: titk@wix.com - Suppress for regression on making TS config stricter. Fix please if you touch this code 🙏
    getDefaultValue: () => null,
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_BILLING_ADDRESS_LABEL: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.billingInfo.label'),
    inheritFromAppScope: true,
  },
  THANK_YOU_PAGE_PAYMENT_METHOD_LABEL: {
    type: SettingsParamType.String,
    getDefaultValue: ({t}) => t('thankYouPage.paymentMethod.label'),
    inheritFromAppScope: true,
  },
});
